// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"markdown_wrapper__2ew_0","content":"markdown_content__2vh_X","asSubPage":"markdown_asSubPage__T7egT"};